import { ExpandMoreRounded } from "@mui/icons-material";
import { Typography, AccordionDetails, AccordionSummary, Accordion } from "@mui/material";
import { FC, useState } from "react"
import { useTranslation } from "react-i18next";
import { ContractPaymentList } from "../page/contract/ContractInterfaces";
import PaymentsHistoryTable from "./PaymentsHistoryTable";

const PaymentsHistoryTableWithAccordion:FC<{data:ContractPaymentList[],showTyphographyInnerTable?:boolean}> = ({data,showTyphographyInnerTable = false}) => {
    const [expanded,setExpanded] = useState(false);
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'contract'}); 
    return <>
    <Accordion
        expanded={expanded}
        onChange={()=>setExpanded((prev:boolean)=> !prev)}
        >
        <AccordionSummary
            expandIcon={<ExpandMoreRounded/>}
            aria-controls="subperiods-content"
            id="superiods-header"
        >
            <Typography>{t('paymentsHistoryTable.title')}</Typography>
        </AccordionSummary>
        <AccordionDetails>
            {data && data.length > 0 &&
              <PaymentsHistoryTable data={data} showTyphography={showTyphographyInnerTable}/>
            }
        </AccordionDetails>
    </Accordion>
    </> 
}



export default PaymentsHistoryTableWithAccordion